import React from 'react'
import './footer.css';
function Footer() {
  return (
    <div className='footer'>Created by Aditya Roshan Patro</div>
  )
}

export default Footer